import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./styles.module.scss";
// Components
import Page from "../../Components/Page";
import DashboardSearch from "../../Components/DashboardSearch";
import DashboardHeader from "../../Components/DashboardHeader";
import DashboardNotificationsSection from "../../Components/DashboardNotificationsSection";
// Utils
import { getIsUserJustAnInstaller, getIsUserStaff } from "../../Services/Utils";
import { useAppSelector } from "State/hooks";

const Dashboard = () => {
  const user = useAppSelector((state) => state.user);
  const userRoles = user?.roles;
  const userIsJustAnInstaller = getIsUserJustAnInstaller(userRoles);
  // Get any pre set filters
  const location = useLocation();
  const [selectedFilter, setSelectedFilter] = useState(
    location.state?.filter || userIsJustAnInstaller ? "installation" : "all"
  );
  // Tabs note: when notifications are selected, onClick updates the URL
  // Tabs note: when clicking "awaiting installation" -> this goes to "users" and updates the filter
  const [selectedTab, setSelectedTab] = useState("users"); // other options: staff, reports

  useEffect(() => {
    if (userIsJustAnInstaller) {
      setSelectedFilter("installation");
    }
  }, [userIsJustAnInstaller]);

  const staffRole = getIsUserStaff(userRoles);

  const noHubsAssigned = user?.hubs?.length === 0;

  return (
    <Page className={styles.page}>
      <div className={styles.content}>
        <DashboardHeader />
        {(staffRole ?? userIsJustAnInstaller) && noHubsAssigned ? (
          <div className={styles.welcome_message_container}>
            <h2 className={styles.welcome_message_title}>Welcome to Lilli!</h2>
            <p>
              You’re almost set up! To view service user data, ask your Lilli
              programme manager to assign you a service user. In the meantime,
              learn how to use Lilli in the Community section.
            </p>
          </div>
        ) : (
          <div className={styles.search_and_notifications_container}>
            <DashboardSearch
              setSelectedFilter={setSelectedFilter}
              selectedFilter={selectedFilter}
              userIsJustAnInstaller={userIsJustAnInstaller}
              setSelectedTab={setSelectedTab}
              selectedTab={selectedTab}
            />
            <DashboardNotificationsSection
              setSelectedFilter={setSelectedFilter}
              setSelectedTab={setSelectedTab}
            />
          </div>
        )}
      </div>
    </Page>
  );
};

export default Dashboard;
